import { AxiosPromise } from 'axios';
import {
  IGetStudent,
  IGetStudents,
  IStudentParams,
  IPasswordReq,
  IStudentWebIdReq,
  IParentPasswordReq,
  IGetStudentAttend,
  IGetShuttleInfo,
  IGetShuttleList,
  IShuttleInfoReq,
  IGetParent,
  IParent,
  IGetStudentTestInfo,
  IGetStudentTestInfoOcean,
  IGetStudentPtInfo,
  IGetStudentClassInfo,
  IGetStudentClassRoomInfo,
  IGetStudentScores,
  IStudentPointParams,
  IGetStudentPoints,
  IShuttleListParams,
  INewStudentParams,
  IGetNewStudents,
} from '../models/students.model';
import { IResponse } from '../models/common.api.model';
import axios from 'axios';
import QueryString from 'qs';

const uri = '/mgmt/students';

export const getStudent = (memberCode: string, campusCode: string): AxiosPromise<IGetStudent> => {
  return axios.get(`${uri}/${memberCode}/${campusCode}`);
};

export const getStudents = (params: IStudentParams): AxiosPromise<IGetStudents> => {
  return axios.get(`${uri}/campus-student`, { params });
};

export const getStudents2 = (params: IStudentParams): AxiosPromise<IGetStudents> => {
  return axios.get(`${uri}/campus-student2`, { params });
};

export const getAllStudents = (): AxiosPromise<IGetStudents> => {
  return axios.get(`${uri}/campus-student`);
};

export const getNewStudents = (campusCode: string, semesterCode: number, params: INewStudentParams): AxiosPromise<IGetNewStudents> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/campus-student/new-student/${campusCode}/${semesterCode}?${qsParams}`);
};

export const getStudentScores = (classCode: string, memberCode: string, learningTypeCode: string): AxiosPromise<IGetStudentScores> => {
  return axios.get(`${uri}/evaluation-score/${classCode}/${memberCode}?learningTypeCode=${learningTypeCode}`);
};

export const getStudentAttend = (
  studentCode: string,
  campusCode: string,
  classCode?: string | null,
): AxiosPromise<IGetStudentAttend> => {
  if(classCode) {
    return axios.get(`${uri}/attend/${studentCode}/${campusCode}?classCode=${classCode}`);
  } else {
    return axios.get(`${uri}/attend/${studentCode}/${campusCode}`);
  }
};

export const updateStudent = (
  studentCode: string,
  campusCode: string,
  data: any,
): AxiosPromise => {
  return axios.put(`${uri}/${studentCode}/${campusCode}`, data);
};

export const updatePassword = (data: IPasswordReq): AxiosPromise => {
  return axios.put(`${uri}/password`, data);
};

export const updateStudentWebId = (data: IStudentWebIdReq): AxiosPromise => {
  return axios.put(`${uri}/web-id`, data);
};

export const checkWebIdDuplicate = (webId: string): AxiosPromise<IResponse<boolean>> => {
  return axios.post('/service/join/duplicate-check', { memberType: 'S', webId });
};

export const updateParentPassword = (data: IParentPasswordReq): AxiosPromise => {
  return axios.put(`${uri}/parent/password`, data);
};

export const getShuttleInfo = (
  campusCode: string,
  studentCode: string,
): AxiosPromise<IGetShuttleInfo> => {
  return axios.get(`${uri}/${campusCode}/shuttle-bus/${studentCode}`);
};

export const getShuttleList = (
  campusCode: string,
  weekdayDiv: string,
  params: IShuttleListParams,
): AxiosPromise<IGetShuttleList> => {
  const qsParams = QueryString.stringify(params);  
  return axios.get(`${uri}/${campusCode}/shuttle-bus/search/${weekdayDiv}?${qsParams}`);
};

export const createShuttleInfo = (
  campusCode: string,
  studentCode: string,
  data: IShuttleInfoReq,
): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/shuttle-bus/${studentCode}`, [data]);
};

export const getParent = (studentCode: string): AxiosPromise<IGetParent> => {
  return axios.get(`${uri}/parent/${studentCode}`);
};

export const updateParent = (
  parentCode: string,
  data: IParent,
): AxiosPromise => {
  return axios.put(`${uri}/parent/${parentCode}`, data);
};

export const getStudentTestInfo = (
  memberCode: string,
): AxiosPromise<IGetStudentTestInfo> =>
  axios.get(`${uri}/test-info/${memberCode}`);

export const getStudentTestOceanInfo = (
  memberCode: string,
): AxiosPromise<IGetStudentTestInfoOcean> =>
  axios.get(`${uri}/test-info/ocean/${memberCode}`);

export const getStudentPtInfo = (
  memberCode: string,
): AxiosPromise<IGetStudentPtInfo> =>
  axios.get(`${uri}/placement-test/${memberCode}`);

export const getStudentClassInfo = (memberCode: string): AxiosPromise<IGetStudentClassInfo> => {
  return axios.get(`${uri}/classes-info/${memberCode}`);
};

export const getStudentClassRoomInfo = (classCode: string): AxiosPromise<IGetStudentClassRoomInfo> => {
  return axios.get(`${uri}/room-info/${classCode}`);
};

export const getStudentPoints = (memberCode: string, params: IStudentPointParams): AxiosPromise<IGetStudentPoints> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/student-point/${memberCode}?${qsParams}`);
};

export const getNotRideStudent = (studentCode: string): AxiosPromise => {
  return axios.get(`${uri}/shuttle-bus/not-ride/${studentCode}`);
}

export const createNotRideStudent = (studentCode: string): AxiosPromise => {
  return axios.post(`${uri}/shuttle-bus/not-ride/${studentCode}`);
};
